import axios from 'axios';
import * as utils from '@/apis/apiUtils';
import type { AxiosResponse } from 'axios';
import type {
  EmergencyResponseTeamMtxsCreateParams,
  EmergencyResponseTeamMtxGetParams,
} from '@/models/apis/externalReports/emergencyResponseTeam/emergencyResponseTeamMtxRequest';
import type { EmergencyResponseTeamMtx } from '@/models/externalReports/emergencyResponseTeam/emergencyResponseTeamMtx';
import type {
  EmergencyResponseTeamMtxResponse,
} from '@/models/apis/externalReports/emergencyResponseTeam/emergencyResponseTeamMtxResponse';
import type { EmptyResponse } from '@/models/index';

export default {
  createEmergencyResponseTeamMTXs(params: EmergencyResponseTeamMtxsCreateParams): Promise<AxiosResponse<EmptyResponse>> {
    return axios.post(utils.getApiUrl('/external_reports/emergency_response_team/mtxs'), params);
  },
  async getMtxsByReportIds(
    params: EmergencyResponseTeamMtxGetParams,
  ): Promise<Record<number, EmergencyResponseTeamMtx[]>> {
    const { data } = await axios.get<EmergencyResponseTeamMtxResponse[]>(
      utils.getApiUrl('/external_reports/emergency_response_team/mtxs'), { params: params || {} },
    );
    return convertEmergencyResponseTeamMtxResponseToEmergencyResponseTeamMtx(data);
  },
};

function convertEmergencyResponseTeamMtxResponseToEmergencyResponseTeamMtx(
  mtxs: EmergencyResponseTeamMtxResponse[],
): Record<number, EmergencyResponseTeamMtx[]> {
  const result: Record<number, EmergencyResponseTeamMtx[]> = {};

  mtxs.forEach((item) => {
    const model: EmergencyResponseTeamMtx = {
      externalReportsEmergencyResponseTeamCarId: Number(item.car_id),
      ts: new Date(item.ts),
      lat: Number(item.lat),
      lon: Number(item.lon),
      status: item.status,
      externalReportsEmergencyResponseTeamReportId: item.report_id,
      companyName: null,
    };

    if (!result[item.report_id]) {
      result[item.report_id] = [];
    }
    result[item.report_id].push(model);
  });

  return result;
}
